import { render, staticRenderFns } from "./OzFocusTrap.vue?vue&type=template&id=0ce9b9a0&"
import script from "./OzFocusTrap.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzFocusTrap.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports